/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  This file used to store the API urls thourgh the application in JSON object format
  EX: https://jsonplaceholderqa.typicode.com/api/GetHomeData
*/
import { useContext } from 'react'
import AppConfigContext from '../../app/AppConfigContext'

const useAPIEndpoints = () => {
  const config = useContext(AppConfigContext)
  const appConfigure = config?.appConfig || config
  const apiUrl =
    appConfigure?.VariableSettings?.CoreDataUIURL ||
    `${process.env.BackOfficeAPIURL}/`
  const summaryBaseUrl =
    appConfigure?.VariableSettings?.summarizationCoreDataUIURL ||
    process.env.summarizationCoreDataUIURL
  const APIEndPoints = {
    GetContactAddress: {
      method: 'post',
      url: `${apiUrl}api/Case/caseId/GetContactAddress`,
    },
    GetPCNDetails: {
      method: 'post',
      url: `${apiUrl}api/Case/Search`,
    },
    GetCorrespondance: {
      method: 'post',
      url: `${apiUrl}api/Case/caseId/GetAttachments`,
    },
    PostOverRide: {
      method: 'post',
      url: `${summaryBaseUrl}api/Summarisation/v1/Summarization/insertvehiclematchdetails`,
    },
    GetSummaryDetails: {
      method: 'get',
      url: `${summaryBaseUrl}api/Summarisation/v1/Summarization/getchallengeandcasevalidationdetails`,
    },
    GetCouncil: {
      method: 'get',
      url: `${apiUrl}api/Contract/Widgets`,
    },
    GetValidationAccuracyByContractid: {
      method: 'get',
      url: `${summaryBaseUrl}/api/Summarisation/v1/Summarization/getvalidationaccuracybycontractid`,
    },
    GetOcrResultsByContractid: {
      method: 'get',
      url: `${summaryBaseUrl}/api/Summarisation/v1/Summarization/getocrresultsbycontractid`,
    },
    GetWeeklySummaryReport: {
      method: 'get',
      url: `${summaryBaseUrl}/api/Summarisation/v1/Summarization/getweeklysummaryreport`,
    },
    GetOverrideReasonCountByContractid: {
      method: 'get',
      url: `${summaryBaseUrl}/api/Summarisation/v1/Summarization/getoverridereasoncountbycontractid`,
    },
    GetOverrideReasonWithDetailByContractid: {
      method: 'post',
      url: `${summaryBaseUrl}/api/Summarisation/v1/Summarization/getoverridereasonwithdetailbycontractid`,
    },
    GetCeoImages: {
      method: 'get',
      url: `${apiUrl}api/Case/`,
    },
  }
  return APIEndPoints
}

export default useAPIEndpoints
